export default __webpack_public_path__ + "static/media/TWS1.9f9df48f.png";